// /src/helpers/createZoomMeeting.js

/**
 * Creates a Zoom meeting via your backend API.
 * @param {Object} params - The meeting parameters
 * @param {string} params.dateTime - ISO string of meeting start
 * @param {string} params.topic - Zoom meeting topic/title
 * @param {string} params.agentEmail - Agent (host) email
 * @param {string} params.tenantEmail - Tenant (invitee) email
 * @returns {Promise<{joinUrl: string, meetingId: string|number}>}
 */
const createZoomMeeting = async ({
    dateTime,
    topic,
    agentEmail,
    tenantEmail,
  }) => {
    const res = await fetch("https://ai-realtor.onrender.com/create-zoom-meeting", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ dateTime, topic, agentEmail, tenantEmail }),
    });
    if (!res.ok) throw new Error("Zoom API error");
    const zoomData = await res.json();
    // Align with your actual API response
    const joinUrl = zoomData.join_url;
    const meetingId = zoomData.meeting_id;
  
    if (!joinUrl || !meetingId) {
      throw new Error("Zoom meeting not created: missing join URL or meeting ID.");
    }
  
    return {
      joinUrl,
      meetingId,
      // You can pass along more fields as needed (start_time etc)
    };
  };
  
  export default createZoomMeeting;
  